import { createFileRoute } from '@tanstack/react-router';
import CompanyEdit from '../../../features/baseData/companies/company/edit';
import {
  COMPANIES_PERMISSIONS,
  createPermissionGuard,
  getPermissionSet,
} from '@bmwe/ui';

export const Route = createFileRoute(
  '/stammdaten/firmen/$companyId_/bearbeiten',
)({
  component: CompanyEdit,
  beforeLoad: createPermissionGuard(
    getPermissionSet(COMPANIES_PERMISSIONS, 'EDIT'),
  ),
});

export const EditCompanyRoute = Route;
